import { useMemo } from 'react';

export default function (options, nonePlaceholder=`None`, allPlaceholder=`All`, captionFormatter) {
  return useMemo(() => {
    if (captionFormatter) return captionFormatter(options, nonePlaceholder, allPlaceholder);

    let activeOptions = options.filter(x => x.isChecked && !x.isGroup);

    if (activeOptions.length && activeOptions[0].value === `any`) return allPlaceholder;
    if (activeOptions.length === options.length) return allPlaceholder;
    if (activeOptions.length === 0) return nonePlaceholder;

    if (activeOptions.length === 1) return activeOptions[0].name || activeOptions[0].value;
    if (activeOptions.length === 2) return `${activeOptions[0].name || activeOptions[0].value} and ${activeOptions[1].name || activeOptions[1].value}`;
    return `${activeOptions[0].name || activeOptions[0].value} and ${activeOptions.length - 1} others`;
  }, [options]);
}
